export default "__VITE_ASSET__D$URvCYI__"